import { v4 as uuidv4 } from 'uuid';
import { TEST_ENGINE_PSIUTD } from './types';

const API = (window.Config && window.Config.api) || 'https://api2-dev.act.org';

const getJSONfromText = async text => {
  let testJson;

  try {
    testJson = JSON.parse(await text());
  } catch (error) {
    testJson = { error: 'test' };
  }

  return testJson;
};

const customFetch = async (url, props = {}) => {
  let testJson, response;

  try {
    response = await fetch(url, props);

    testJson = await response.json();
  } catch (error) {
    testJson = await getJSONfromText(response && response.text);
  }

  return {
    ok: (response && response.ok) || false,
    json: testJson,
    status: (response && response.status) || 403,
  };
};

class Requests {
  static authorize(user) {
    return customFetch(
      `${API}/tdltlp_1.0.0/authorize?launch_code=${user.launchCode}&room_code=${user.roomCode}&email=${encodeURIComponent(user.email)}&ip_address=${user.ip_address}&user_agent=${encodeURIComponent(navigator.userAgent)}&device_id=${user.device_id}`,
    );
  }

  static getUser(user) {
    return customFetch(
      `${API}/tdltlp_1.0.0/user/${user.reg_id}/registration?admin_id=${user.admin_id}`,
      {
        method: 'GET',
        headers: {
          Authorization: user.token,
        },
      },
    );
  }

  static relaunch(data) {
    return customFetch(
      `${API}/tdltlp_1.0.0/remoteProctor/relaunch?email=${data.email}&launch_code=${data.activation_code}&remote_proctor_service_id=${data.remote_proctor_service_id}`,
    );
  }

  static getAddress(user) {
    return customFetch(
      `${API}/tdltlp_1.0.0/user/${user.reg_id}/addresses?admin_id=${user.admin_id}`,
      {
        method: 'GET',
        headers: {
          Authorization: user.token,
        },
      },
    );
  }

  static updateCofirmationInd(data) {
    const body = JSON.stringify({
      admin_id: data.admin_id,
      confirmation_ind: data.confirmation_ind,
    });
    return customFetch(`${API}/tdltlp_1.0.0/user/${data.registration_id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: data.token,
      },
      body,
    });
  }

  static putAddress(user) {
    const body = JSON.stringify({
      admin_id: user.admin_id,
      address: user.address,
    });
    return customFetch(`${API}/tdltlp_1.0.0/user/${user.reg_id}/addresses`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: user.token,
      },
      body,
    });
  }

  static getTerms(admin) {
    return customFetch(`${API}/tdltlp_1.0.0/admin/${admin.admin_id}/terms`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: admin.token,
      },
    });
  }

  static getDirections(admin) {
    return customFetch(
      `${API}/tdltlp_1.0.0/admin/${admin.admin_id}/directions`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: admin.token,
        },
      },
    );
  }

  static putTerms(user) {
    const body = JSON.stringify({
      admin_id: user.admin_id,
      action: 'accept',
      requester: 'PORTAL',
      reason: 'NORMAL',
    });
    return customFetch(`${API}/tdltlp_1.0.0/user/${user.reg_id}/terms`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: user.token,
      },
      body,
    });
  }

  static getAssessments(user) {
    return customFetch(
      `${API}/tdltlp_1.0.0/user/${user.reg_id}/assessment?admin_id=${user.admin_id}&requester=PORTAL`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: user.token,
        },
      },
    );
  }

  static ledata(field, token) {
    const body = JSON.stringify({
      launch_engine: field.launch_engine,
      information: {
        launch_url: field.launch_url,
        post_body: JSON.parse(field.post_body),
        oauth_version: '1.0',
        service: 'ACT',
        role: 'Learner',
      },
    });

    return customFetch(`${API}/tdltlp_1.0.0/assessment/ledata`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        'Launch-Engine':
          field.launch_engine === TEST_ENGINE_PSIUTD
            ? field.launch_engine
            : uuidv4(),
      },
      body,
    });
  }

  static sign(field, token) {
    const body = JSON.stringify({
      launch_url: field.launch_url,
      post_body: JSON.parse(field.post_body),
      oauth_version: '1.0',
      service: 'ACT',
      role: 'Learner',
    });

    return customFetch(`${API}/tdltlp_1.0.0/LTI/sign`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body,
    });
  }
  static putAssessment(body, regId, token) {
    return customFetch(`${API}/tdltlp_1.0.0/user/${regId}/assessment`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body,
    });
  }
  static postHistory(body, token) {
    return customFetch(`${API}/tdltlp_1.0.0/history`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body,
    });
  }
}

export default Requests;
